import { render } from "./HeaderFornecedor.vue?vue&type=template&id=8db57b30&scoped=true"
import script from "./HeaderFornecedor.vue?vue&type=script&lang=js"
export * from "./HeaderFornecedor.vue?vue&type=script&lang=js"

import "./HeaderFornecedor.vue?vue&type=style&index=0&id=8db57b30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db57b30"]])

export default __exports__